// API endpoints
export const CHAT_ENDPOINTS = {
  ROOMS: "/chat/rooms",
  ROOM: (id: string) => `/chat/rooms/${id}`,
  MARK_AS_READ: (id: string) => `/chat/rooms/${id}/mark_as_read`,
  ADD_MEMBERS: (id: string) => `/chat/rooms/${id}/add_members`,
  REMOVE_MEMBER: (id: string) => `/chat/rooms/${id}/remove_member`,
  LEAVE: (id: string) => `/chat/rooms/${id}/leave`,
  MESSAGES: (roomId: string) => `/chat/rooms/${roomId}/messages`,
  MESSAGE: (roomId: string, messageId: string) => `/chat/rooms/${roomId}/messages/${messageId}`,
  SEARCH_MESSAGES: (roomId: string) => `/chat/rooms/${roomId}/messages/search`,
  USERS: "/chat/users",
  PUSHER_AUTH: "/chat/pusher/auth",
  PUSHER_HEARTBEAT: "/chat/pusher/heartbeat",
  PUSHER_TYPING: "/chat/pusher/typing",
} as const;

// React Query keys
export const CHAT_QUERY_KEYS = {
  all: ["chat"] as const,
  rooms: () => [...CHAT_QUERY_KEYS.all, "rooms"] as const,
  room: (id: string) => [...CHAT_QUERY_KEYS.rooms(), id] as const,
  messages: (roomId: string) => [...CHAT_QUERY_KEYS.all, "messages", roomId] as const,
  messagesSearch: (roomId: string, query: string) => [...CHAT_QUERY_KEYS.messages(roomId), "search", query] as const,
  users: () => [...CHAT_QUERY_KEYS.all, "users"] as const,
};

// Chat constants
export const CHAT_CONFIG = {
  MAX_ATTACHMENTS: 5,
  MAX_FILE_SIZE_MB: 10,
  MAX_FILE_SIZE_BYTES: 10 * 1024 * 1024,
  MESSAGES_LIMIT: 100,
  TYPING_DEBOUNCE_MS: 300,
  TYPING_TIMEOUT_MS: 3000,
  HEARTBEAT_DEBOUNCE_MS: 5000,
  IDLE_THRESHOLD_MS: 5 * 60 * 1000, // 5 minutes
  STATUS_CHECK_INTERVAL_MS: 30 * 1000, // 30 seconds
  ROOMS_REFETCH_INTERVAL_MS: 60 * 1000, // 1 minute
} as const;

// Accepted file types for attachments
export const ACCEPTED_FILE_TYPES = "image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt";
